// src/pages/blogs/LearnBiomedicalEngineeringMathsForBeginners.js

import React from 'react';

const LearnBiomedicalEngineeringMathsForBeginners = () => {
  return (
    <div>
      <div className='main'>
        <div className="column1"></div>
        <div className="column2">
          <br />
          <br />
          <div style={{ textAlign: 'center' }}>
            <h1>LearnBiomedicalEngineeringMathsForBeginners</h1>
          </div>
          <p>
            Our Events are hosted locally in Australia and globally through online live video feeds.
            Feel free to drop into any at your own discretion.
          </p>
        </div>
        <div className="column3"></div>
      </div>
    </div>
  );
};

export default LearnBiomedicalEngineeringMathsForBeginners;
